import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO'
import { tr, enGB } from 'date-fns/locale'
import store from 'store';

const formatDate = (date, dateFormat = 'd MMMM yyyy, HH:mm', newOpts = {}) => {
	let opts = {
		parsed: false,
		...newOpts,
	}
	if(date) {
		const curState = store.getState();
		try {
			if(!opts.parsed) {
				date = parseISO(date);
			}
			const returnDate = format(date, dateFormat, { ...opts, locale: (curState.translation.activeLanguage === 'tr' ? tr : enGB) });
			return returnDate;
		}
		catch(e) {
			console.warn('Invalid date:', e);
			return '<Hatalı Tarih>';
		}
	}
	else {
		return 'Hatalı Tarih';
	}
}

export default formatDate